export default "__VITE_ASSET__CypUlkOR__"